class Unauthenticated extends Error {
    constructor(message = 'Unauthenticated. You are not authenticated or you are authenticated incorrectly. Please try to authenticate again.') {
      super(message)
      this.name = this.constructor.name
      this.status = 401
      Error.captureStackTrace(this, this.constructor)
    }
}

module.exports = Unauthenticated
